import React, {Component} from 'react';
import '../../App.css';
import StreamContent from '../ReUsableComponent/StreamContent';

    function StreamLearning() {
        return (
          <>
              <StreamContent />
          </>
        )
      }
    
    export default StreamLearning;